import {GraphQLClient} from 'graphql-request';

const GAUS_WINDOW_GRAPHQL_ENDPOINT = process.env.NEXT_PUBLIC_GAUS_WINDOW_API + '/graphql';
export const graphQLClient = new GraphQLClient(GAUS_WINDOW_GRAPHQL_ENDPOINT);
